import { gql } from '@apollo/client';

export const PATCH_TAG_MUTATION = gql`
    mutation patchTag($input: PatchTagInput!) {
        result: patchTag(input: $input) {
            id
            name
            slug
            metadata
            createdAt
            updatedAt
        }
    } 
`;
